import template from './trip-item-eurail-journey.html';
const DIRECTIVE_NAME = TripItemEuRailJourney.DIRECTIVE_NAME = 'ktTripItemEurailJourney';
export default function TripItemEuRailJourney() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripItemEuRailJourneyController,
        controllerAs: '$ctrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            recommendation: `=${DIRECTIVE_NAME}Recommendation`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
        },
        link: function($scope, $elem, $attrs, tripItemEuRailJourneyCtrl) {
            tripItemEuRailJourneyCtrl.$onInit();
        },
    };
}

export function TripItemEuRailJourneyController(
    userService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        vm.regionalSettings = userService.getRegionalSettings();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-eurail-journey/trip-item-eurail-journey-component.js